import trackingEventDictionary from "@core/dictionary/tracking-event";
import { getApiUrl } from "@utils/baseUrl";

export const panelData = [
  {
    id: "port_of_lading",
    text: "As Port of Lading",
    redirectionEnum: "portOfLading",
    eventEnum: "portOfLading",
  },
  {
    id: "port_of_unlading",
    text: "As Port of Unlading",
    redirectionEnum: "portOfUnlading",
    eventEnum: "portOfUnlading",
  },
];

export const profileTabs = [
  {
    id: "overview",
    text: "Trade Overview",
    isExcludeFilter: true,
  },
  {
    id: "freight_forwarder",
    text: "Freight Forwarders",
    countEnum: "freightForwarderCount",
    redirectionEnum: "freightForwarder",
  },
  {
    id: "vocc",
    text: "VOCC",
    countEnum: "voccCount",
    redirectionEnum: "vocc",
  },
  {
    id: "nvocc",
    text: "NVOCC",
    countEnum: "nvoccCount",
    redirectionEnum: "nvocc",
  },
  // {
  //   id: "vessel",
  //   text: "Vessels",
  //   countEnum: "vesselCount",
  //   redirectionEnum: "vessel",
  // },
  {
    id: "importers",
    text: "Consignee",
    countEnum: "importersCount",
  },
  {
    id: "exporters",
    text: "Shippers",
    countEnum: "exportersCount",
  },
];

export const portsEvent = {
  freight_forwarder: {
    tab: trackingEventDictionary.tradeFrieghtForwardersTab,
    tabDownload: trackingEventDictionary.tradeFrieghtForwardersTabDownload,
    profileClick: trackingEventDictionary.tradeFrieghtForwardersTabFrieghtForwardersProfileClick,
    viewShipments: trackingEventDictionary.tradefrieghtForwardersTabfrieghtForwardersProfileViewShipments,
  },
  vocc: {
    tab: trackingEventDictionary.tradeVoccTab,
    tabDownload: trackingEventDictionary.tradeVoccTabDownload,
    profileClick: trackingEventDictionary.tradeVoccTabVoccProfileClick,
    viewShipments: trackingEventDictionary.tradeVoccTabVoccProfileViewShipments,
  },
  nvocc: {
    tab: trackingEventDictionary.tradeNvoccTab,
    tabDownload: trackingEventDictionary.tradeNvoccTabDownload,
    profileClick: trackingEventDictionary.tradeNvoccTabNvoccProfileClick,
    viewShipments: trackingEventDictionary.tradeNvoccTabNvoccProfileViewShipments,
  },
  importers: {
    tab: trackingEventDictionary.tradeImportersTab,
    tabDownload: trackingEventDictionary.tradeImportersTabDownload,
    profileClick: trackingEventDictionary.tradeImportersTabImportersProfileClick,
    viewShipments: trackingEventDictionary.tradeImportersTabImportersProfileViewShipments,
  },
  exporters: {
    tab: trackingEventDictionary.tradeExportersTab,
    tabDownload: trackingEventDictionary.tradeExportersTabDownload,
    profileClick: trackingEventDictionary.tradeExportersTabExportersProfileClick,
    viewShipments: trackingEventDictionary.tradeExportersTabExportersProfileViewShipments,
  },
  vessel: {
    tab: trackingEventDictionary.tradeVesselTab,
    tabDownload: trackingEventDictionary.tradeVesselTabDownload,
  },
  overview: {
    tab: trackingEventDictionary.tradeOverViewTab,
    tradeLanes: trackingEventDictionary.tradeOverviewTabTradeLanes,
    tradeCountries: trackingEventDictionary.tradeOverviewTabTradeCountries,
    portOfLading: trackingEventDictionary.tradeOverviewTabAsPortOfLading,
    portOfUnLading: trackingEventDictionary.tradeOverviewTabAsPortOfUnLading,
  },
  landing: trackingEventDictionary.landing,
  viewShipments: trackingEventDictionary.viewShipments,
};

export const logisticsEvent = {
  importers: {
    tab: trackingEventDictionary.tradeConsigneeTab,
    tabDownload: trackingEventDictionary.tradeConsigneeTabDownload,
    profileClick: trackingEventDictionary.tradeConsigneeTabCompanyProfileClick,
    viewShipments: trackingEventDictionary.tradeConsigneeTabCompanyProfileViewShipements,
  },
  exporters: {
    tab: trackingEventDictionary.tradeShipperTab,
    tabDownload: trackingEventDictionary.tradeShipperTabDownload,
    profileClick: trackingEventDictionary.tradeShipperTabCompanyProfileClick,
    viewShipments: trackingEventDictionary.tradeShipperTabCompanyProfileViewShipements,
  },
  overview: {
    tab: trackingEventDictionary.tradeOverViewTab,
    tradeLanes: trackingEventDictionary.tradeOverviewTabTradeLanes,
    tradeCountries: trackingEventDictionary.tradeOverviewTabTradeCountries,
    tradePorts: trackingEventDictionary.tradeOverviewTabTradePorts,
  },
  contact_details: {
    tab: trackingEventDictionary.tradeContactDetailsTab,
    fetchContacts: trackingEventDictionary.tradeContactDetailsTabFetchContacts,
  },
  landing: trackingEventDictionary.landing,
  viewShipments: trackingEventDictionary.viewShipments,
};

export const portsCategoryData = [
  {
    id: "trade_lane",
    value: "Top Trade Lanes",
    eventEnum: "tradeLanes",
    countEnum: "trade_lane_count",
  },
  {
    id: "trade_country",
    value: "Trade Countries",
    eventEnum: "tradeCountries",
    countEnum: "trade_country_count",
  },
];

export const portProfileAPIEndPoints = {
  getProfileHeaderDetails: getApiUrl("profileDetails"),
  getUserPlanDetails: getApiUrl("getUserCreditsByPlan"),
  getMapData: getApiUrl("profileMapData"),
  getShipperDetails: getApiUrl("profileMapData"),
};

const logisticsProfileAPIEndPoints = {
  getProfileHeaderDetails: getApiUrl("profileDetails"),
  getUserPlanDetails: getApiUrl("getUserCreditsByPlan"),
  getMapData: getApiUrl("profileMapData"),
  getShipperDetails: getApiUrl("profileMapData"),
};

export const profileTypeEndPoint = {
  ports: portProfileAPIEndPoints,
  logistics: logisticsProfileAPIEndPoints,
  getShipmentDistribution: getApiUrl("profileSummaryData"),
  getCompanySlug: getApiUrl("companyProfiles/getSlug"),
  getInTouch: getApiUrl("notifySales"),
  getUserPlanDetails: getApiUrl("getUserCreditsByPlan"),
  downloadProfileExcel: getApiUrl("download_profiles_excel_data"),
  getContactScaningData: getApiUrl("getContactScaningData"),
  downloadContacts: getApiUrl("download_contacts"),
  viewContacts: getApiUrl("CompanyContactDetails/getCompanyContactsList"),
  contactDetailsApiUrl: getApiUrl("CompanyContactDetails/getContactDetails"),
  getViewedContacList: getApiUrl("CompanyContactDetails/getViewedContact"),
};

export const countryProductId = {
  us: "trademo_US",
  uruguay: "trademo_UY",
  mexico: "trademo_MX",
  chile: "trademo_CH",
  colombia: "trademo_CO",
  argentina: "trademo_AR",
  panama: "trademo_PA",
  ecuador: "trademo_EC",
  peru: "trademo_PR",
  uk: "trademo_UK",
  multicountry: "trademo_MC",
  philippines: "trademo_PH",
  vietnam: "trademo_VN",
  india: "trademo_INMR3",
  inmr3: "trademo_INMR3",
  bangladesh: "trademo_BD",
  kazakhstan: "trademo_KZ",
  "sri-lanka": "trademo_LK",
  pakistan: "trademo_PK",
  uzbekistan: "trademo_UZ",
  botswana: "trademo_BW",
  "ivory-coast": "trademo_CI",
  cameroon: "trademo_CM",
  ghana: "trademo_GH",
  lesotho: "trademo_LS",
  namibia: "trademo_NA",
  nigeria: "trademo_NG",
  uganda: "trademo_UG",
  ethiopia: "trademo_ET",
  paraguay: "trademo_PY",
  "costa-rica": "trademo_CR",
  rwanda: "trademo_RW",
  "global data": "trademo_GLOBAL",
  //mirror dataset
  brazil: "trademo_BR",
  indonesia: "trademo_ID",
  "indonesia nm": "trademo_IDNM",
  "india mirror": "trademo_INMR",
  russia: "trademo_RU",
  "russia nm": "trademo_RUNM",
  china: "trademo_CN",
  singapore: "trademo_SG",
  malaysia: "trademo_MY",
  thailand: "trademo_TH",
  turkey: "trademo_TR",
  "united-arab-emirates": "trademo_AE",
  australia: "trademo_AU",
  "middle east": "trademo_MIDDLEEAST",
  europe: "trademo_EU",
  canada: "trademo_CA",
  germany: "trademo_DE",
  "south korea": "trademo_KR",
  "hong kong": "trademo_HK",
  "saudi arabia": "trademo_SA",
  japan: "trademo_JP",
  taiwan: "trademo_TW",
  "us mirror": "trademo_USM",
  "mexico maritime": "trademo_MXM",
};

export const logisticsTabData = [
  {
    id: "overview",
    text: "Trade Overview",
    isExcludeFilter: true,
  },
  {
    id: "importers",
    text: "Consignee",
    countEnum: "importersCount",
  },
  {
    id: "exporters",
    text: "Shipper",
    countEnum: "exportersCount",
  },
  {
    id: "contact_details",
    text: "Contact Details",
    isExcludeFilter: true,
  },
];

export const logisticsCategoryData = [
  {
    id: "trade_country",
    value: "Trade Countries",
    eventEnum: "tradeCountries",
  },
  {
    id: "trade_port",
    value: "Top Trade Ports",
    eventEnum: "tradePorts",
  },
  {
    id: "trade_lane",
    value: "Top Trade Lanes",
    eventEnum: "tradeLanes",
  },
];

export const tableMapData = {
  importers: {
    count: "importers_count",
    data: "importers",
    redirectionType: "company",
    isRedirectCallingSlug: true,
    redirectionUrl: "ports",
    isRedirect: true,
    profileType: "importers",
  },
  freight_forwarder: {
    count: "freight_forwarder_count",
    data: "freight_forwarder",
    redirectionType: "logistics",
    isRedirectCallingSlug: false,
    redirectionUrl: "logistic-companies",
    isRedirect: false,
    profileType: "freightForwarder",
  },
  vocc: {
    count: "vocc_count",
    data: "vocc",
    redirectionType: "logistics",
    isRedirectCallingSlug: false,
    redirectionUrl: "logistic-companies",
    isRedirect: false,
    profileType: "vocc",
  },
  nvocc: {
    count: "nvocc_count",
    data: "nvocc",
    redirectionType: "logistics",
    isRedirectCallingSlug: false,
    redirectionUrl: "logistic-companies",
    isRedirect: false,
    profileType: "nvocc",
  },
  vessel: {
    count: "vessel_count",
    data: "vessel",
    isRedirect: false,
    redirectionType: "company",
    isRedirectCallingSlug: false,
    redirectionUrl: "logistic-companies",
    profileType: "vessel",
  },
  exporters: {
    count: "exporters_count",
    data: "exporters",
    redirectionType: "company",
    isRedirectCallingSlug: true,
    redirectionUrl: "ports",
    isRedirect: true,
    profileType: "exporters",
  },
  trading_partner: {
    count: "trading_partner_count",
    data: "trading_partner",
    redirectionType: "company",
    isRedirectCallingSlug: true,
    redirectionUrl: "ports",
    isRedirect: true,
    profileType: "exporters",
    partnerType: {
      exporters: "importers",
      importers: "exporters",
    },
  },
  hs_code: {
    count: "hs_code_count",
    data: "hs_code",
    redirectionType: "company",
    isRedirectCallingSlug: true,
    redirectionUrl: "ports",
    isRedirect: true,
    profileType: "exporters",
  },
};

export const getTabDetails = {
  importers: "I",
  consignee: "E",
};

export const getProfileName = {
  port: "Port Profile",
  logistics: "Logistics Profile",
};

export const profileTypeEnum = {
  ports: "port",
  logistics: "logistics",
  company: "company",
  tradeLanes: "trade_region",
};

export const getProfileTypeEnum = {
  portOfLading: "port",
  portOfUnlading: "port",
  vocc: "logistics",
  nvocc: "logistics",
  freightForwarder: "logistics",
  tradeLane: "tradeLane",
  hsCode: "hsCode",
};

export const eventNameEnum = {
  ports: "port_profile_page_",
  logistics: "logistics_profile_page_",
  tradeLanes: "trade_lane_profile_page_",
  company: "company_profile_page_",
};

export const isValidStringRegex = /[a-zA-Z0-9]/;
